export const DUPLICATE_EMAIL_MESSAGE =
  "An account with this email already exists. Please sign in.";

export const RATE_LIMITED_MESSAGE =
  "Too many accounts have been created from your network recently. Please try again later or contact support.";

// The pre-409 backend answers a duplicate signup with this exact plain-text
// body. Production still returns it until the 409 deploy lands, and /api/v1
// returns it permanently, so both shapes have to stay supported.
const LEGACY_DUPLICATE_EMAIL_BODY = "Email already exists";

const parseBody = (body) => {
  if (body && typeof body === "object") return body;
  if (typeof body !== "string") return null;
  try {
    return JSON.parse(body);
  } catch {
    return null;
  }
};

/**
 * True when a failed signup request was rejected because the email is taken.
 *
 * Matches the machine-readable `code` rather than `message` — the copy is
 * expected to change, the code is the stable contract.
 *
 * @param {Object} error - Axios error from a signup POST
 */
export const isDuplicateEmailError = (error) => {
  const response = error?.response;
  if (!response) return false;

  if (response.status === 409) {
    return parseBody(response.data)?.code === "EMAIL_EXISTS";
  }

  if (response.status === 400) {
    return (
      typeof response.data === "string" &&
      response.data.trim() === LEGACY_DUPLICATE_EMAIL_BODY
    );
  }

  return false;
};

/**
 * True when a signup was rejected by the backend's per-IP signup rate limiter.
 *
 * This is a "come back later" condition, not a form error: nothing the user
 * types will change the outcome, so callers should show RATE_LIMITED_MESSAGE
 * rather than echoing the response body.
 *
 * @param {Object} error - Axios error from a signup POST
 */
export const isRateLimitedError = (error) => error?.response?.status === 429;
